import { render, staticRenderFns } from "./IrisLoader.vue?vue&type=template&id=0de35de2&"
import script from "./IrisLoader.vue?vue&type=script&lang=js&"
export * from "./IrisLoader.vue?vue&type=script&lang=js&"
import style0 from "./IrisLoader.vue?vue&type=style&index=0&id=0de35de2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports